import { clearSignupDraft } from '@app/features/onboarding/onboarding';
import { LoadingBlock } from '@core/component/LoadingBlock';
import { virtualKeyboardVisible } from '@core/mobile/virtualKeyboard';
import { getNativeMobilePlatform } from '@core/util/platform';
import { useNavigate, useSearchParams } from '@solidjs/router';
import { onMount } from 'solid-js';
import { AuthProvider } from './context/auth-context';
import { sessionTokenParam } from './core/email-code';
import { createAppAuthContext } from './create-app-auth-context';
import { AuthView } from './views/auth-view';

/** Atlas accounts are enabled by the operator; all platforms use the same login. */
export function Login(_props: { signupMode?: boolean }) {
  const [params] = useSearchParams();
  const email = typeof params.email === 'string' ? params.email : undefined;
  return (
    <AuthProvider value={createAppAuthContext()}>
      <AuthView
        intent="login"
        showApple={getNativeMobilePlatform() === 'ios'}
        compact={virtualKeyboardVisible()}
        initialEmail={email}
        autoStart={import.meta.env.DEV && email !== undefined}
        token={sessionTokenParam(params.token)}
        signedIn={() => <PostLoginRedirect />}
      />
    </AuthProvider>
  );
}

/** Login init runs in the per-method handlers; no tutorial or checkout gate. */
function PostLoginRedirect() {
  const navigate = useNavigate();
  onMount(() => {
    clearSignupDraft();
    navigate('/', { replace: true });
  });
  return <LoadingBlock />;
}

/** Preserve old mobile links without offering public registration. */
export function MobileWebSignup() {
  return <Login />;
}
